export default __webpack_public_path__ + "static/personal-a5ee7d8e019fce09337c64d4aca56728.svg";